/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CanDisableVerifactu200Response
 */
export interface CanDisableVerifactu200Response {
    /**
     * 
     * @type {boolean}
     * @memberof CanDisableVerifactu200Response
     */
    canDisable: boolean;
}

/**
 * Check if a given object implements the CanDisableVerifactu200Response interface.
 */
export function instanceOfCanDisableVerifactu200Response(value: object): value is CanDisableVerifactu200Response {
    if (!('canDisable' in value) || value['canDisable'] === undefined) return false;
    return true;
}

export function CanDisableVerifactu200ResponseFromJSON(json: any): CanDisableVerifactu200Response {
    return CanDisableVerifactu200ResponseFromJSONTyped(json, false);
}

export function CanDisableVerifactu200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CanDisableVerifactu200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'canDisable': json['canDisable'],
    };
}

export function CanDisableVerifactu200ResponseToJSON(json: any): CanDisableVerifactu200Response {
    return CanDisableVerifactu200ResponseToJSONTyped(json, false);
}

export function CanDisableVerifactu200ResponseToJSONTyped(value?: CanDisableVerifactu200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canDisable': value['canDisable'],
    };
}

